// extracted by mini-css-extract-plugin
export default {"leftSideWrapper":"T6cbxS","center":"AU9seg","backBtn":"eRE5Ax"};